import React, { memo } from 'react';
import cls from './Avatar.module.css';
import { Task } from 'entities/task/model/types/tasks';
import { Icon } from 'shared/ui';
import { useAppSelector } from 'store';
import classNames from 'classnames';

interface AvatarProps {
    task: Task;
}

const colorMapping = {
    '#9DA1AC': 'gray',
    '#22B7D7': 'mint',
    '#ECD71F': 'yellow',
    '#F16767': 'red',
    '#FC67FF': 'pink',
    '#CE66F1': 'majenta',
};

export const Avatar = memo(({ task }: AvatarProps) => {
    const { employees } = useAppSelector((state) => state.tasksInformationReducer);

    let executor = null;

    if (task?.involved?.executor_id) {
        executor = employees.find((employee) => employee.id === task.involved.executor_id);
    }

    if (executor && executor?.avatar_url) {
        return (
            <div className={classNames(cls.avatar, cls[colorMapping[task.context.color]])}>
                <img src={executor.avatar_url} alt="avatar" />
            </div>
        );
    }

    return (
        <>
            {task.type === 'custom' ? (
                <Icon iconName={'customTaskIcon'} fill={task.context.color} />
            ) : (
                <Icon iconName={'systemTaskIcon'} fill={task.category} />
            )}
        </>
    );
});
